
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.231 8.863a.75.75 0 01.75.75v3.231a.75.75 0 01-.75.75H1a.75.75 0 010-1.5h2.481V9.613a.75.75 0 01.75-.75zm8.944-5.713a.75.75 0 01.75-.75h3.232a.75.75 0 110 1.5h-2.482v2.482a.75.75 0 01-1.5 0V3.15z","fill":"currentColor"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13.609 2.607a.75.75 0 011.06.022 7.753 7.753 0 01-8.575 12.525.75.75 0 01.577-1.385 6.253 6.253 0 006.916-10.102.75.75 0 01.022-1.06zm-2.122-.378A6.254 6.254 0 004.57 12.328a.75.75 0 01-1.083 1.037A7.754 7.754 0 0112.062.843a.75.75 0 11-.575 1.386z","fill":"currentColor"}})])
          )
        }
      }
    